<h3 class="font-weight-bold">Jugador - {{data.name}}</h3>
<table *ngIf="data.feedbacks.length > 0; else elseBlock">
  <thead>
    <tr>
      <th class="text-align-left">Tópico</th>
      <th class="text-align-right">Calificación</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of data.feedbacks">
      <td>
        <span>{{item.topic}}</span>
      </td>
      <td class="text-align-right">
        <span class="mr-2">{{item.score.toFixed(1)}}</span>
        <i class="material-icons text-pilka-md">star</i>
      </td>
    </tr>
  </tbody>
</table>
<ng-template #elseBlock>No hay datos registrados para este jugador</ng-template>
